import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames';
import MenuPaused from './MenuPaused';
import Loader from "../../../components/loaders/Loader";
import {getWorkHours, getDeliveryWorkHours} from '../../../components/common';
import MenuClosed from './MenuClosed';
import { useRestaurant } from '../../../contexts/restaurant.context';
import {
    setPaymentMethod,
    setOrderMethod,
    showCartCategoryMixAlert
} from '../../../store/actions/checkout.actions';
import { hideMenuItem, showCategoryDisabledAlert, showMenuItem } from '../../../store/actions/menu.actions';
import { addItemToCart, cartResetSpecialCategory, cartSetSpecialCategory } from '../../../store/actions/cart.actions';
import SelectMenuItemDialog from '../../../components/SelectMenuItemDialog';
import MenuCategoryAlert from '../../../components/MenuCategoryAlert';
import CartCategoryMixAlert from '../../../components/CartCategoryMixAlert';
import { deepEqual } from '../../../utils/deep-equal.util';
import { getRestaurantData } from '../../../store/actions/restaurant.actions';
import { Modal } from '../../../components/Modal';
import MoreInfo from '../components/MoreInfo';
import { FullScreenPopup } from '../../../components/FullScreenPopup';
import { useCategoryGroup } from '../../../contexts/category-group.context';
import { showCartButton } from '../../../store/actions/common.actions';
import { getSessionSettingsStorage } from '../../../store/session-storage';
import { orderMethods, paymentMethods } from '../../../constants/checkout';
import { splitAddress } from '../../../utils/address';

const filterItems = (items, search) => {
    if (search.length === 0) { return items; }

    return items.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())
        || item.description.toLowerCase().includes(search.toLowerCase())
        || item.options.some((option) =>
            option.option_labels.some((label) => label.name.toLowerCase().includes(search.toLowerCase())
                || label.description.toLowerCase().includes(search.toLowerCase()))
            )
        || item.keywords.some((keyword) => keyword.toLowerCase().includes(search.toLowerCase()))
    )
};

const cumulativeOffset = (element) => {
    let top = 0, left = 0;
    do {
        top += element?.offsetTop  || 0;
        left += element?.offsetLeft || 0;
        element = element?.offsetParent;
    }
    while (element);

    return {
        top: top,
        left: left
    };
};

function Menu() {
    const restaurant = useRestaurant();

    const dispatch = useDispatch();
    
    const categories = restaurant.menu_categories;

    const {theme} = restaurant;
    // const restaurantAddress = splitAddress(restaurant?.address ?? '');
    const restaurantAddress = restaurant?.address ?? '';

    const cart = useSelector(state => state.cart.items);
    const specialCategory = useSelector(state => state.cart.specialCategory);
    const orderMethod = useSelector((state) => state.checkout.orderMethod);
    const paymentMethod = useSelector((state) => state.checkout.paymentMethod);
    const selectedItem = useSelector(state => state.menu.selectedItem);

    const [search, setSearch] = useState('');
    const [offerItems, setOfferItems] = useState([]);
    const [popularItems, setPopularItems] = useState([]);
    const [data, setData] = useState([]);
    const [dataSpecial, setDataSpecial] = useState([]);
    const [scrollToElement, setScrollToElement] = useState(null);
    const [isShowCategoriesMenu, setIsShowCategoriesMenu] = useState(false);
    const [isShowMoreInfo, setIsShowMoreInfo] = useState(false);
    
    const stickyCategoriesRef = useRef(null);
    const categoriesRef = useRef(null);
    const scrollCategoriesLeft = useRef(null);
    const scrollCategoriesRight = useRef(null);
    const [stickyCategoriesElOffset, setStickyCategoriesElOffset] = useState(-1);
    
    const [categoryGroup, setCategoryGroup] = useCategoryGroup();
    const [categorySlider, setCategorySlider] = useState([]);
    const [isClosedRestaurant, setIsClosedRestaurant] = useState(false);

    const [isShowModal, setIsShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [currentHours, setCurrentHours] = useState(null);
    const [isOpen24Hours, setIsOpen24Hours] = useState(false);
    const [isHideEstimateReadyMessage, setIsHideEstimateReadyMessage] = useState(false);
    
    const [isHaveOrderMethods, setIsHaveOrderMethods] = useState(false);
    const [isHaveOrderPaymentMethods, setIsHaveOrderPaymentMethods] = useState(false);
    
    const [openCategoriesPopup, setOpenCategoriesPopup] = useState(false);

    const [isGroup, setIsGroup] = useState(false);
    const [expandedAllCategories, setExpandedAllCategories] = useState(true);

    const group_id = getSessionSettingsStorage('group_id');
    
    const handleToggleExpandedAllCategories = () => {
        setExpandedAllCategories((prevState) => !prevState);
    };
    
    const handleToggleShowMoreInfo = (e) => {
        e?.preventDefault();
        setIsShowMoreInfo(prevState => !prevState);
    }; 
    
    const handlerCategoryToggle = (e) => {
        e.target.closest('li').classList.toggle('fon-open');
    };

    const handlerShowMenuItem = (e, item) => {
        e.preventDefault();

        const category = categories.find((category, index) => category.items.some((it) => it.id === item.id));

        const cartItemIds = cart.map((item) => item.id);
        const cartCategories = categories.filter((category) =>
            category.items.some((item) => cartItemIds.includes(item.id))
        );
        const cartCategoryIds = cartCategories.map((category) => category.id);
        const cartCategoryGroupWithForcedSchedule = restaurant.menu_category_groups
            .filter((group) =>
                group.categories.filter((id) => cartCategoryIds.includes(id)).length > 0
            )
            .filter((group) => group.is_use_custom_schedule)
        ;
        // const cartCategoryGroupWithForcedScheduleIds = cartCategoryGroupWithForcedSchedule.map((group) => group.id);
        const cartCategoriesWithForcedScheduleIds = cartCategories
            .filter((category) =>
                cartCategoryGroupWithForcedSchedule.some((group) =>
                    group.categories.includes(category.id)
                )
            )
            .map((category) => category.id)
        ;
        const categoryGroup = restaurant.menu_category_groups
            .find((group) =>
                group.categories.includes(category.id)
            )
        ;

        const allowOrderForCustomSchedule = !!categoryGroup && categoryGroup.is_use_custom_schedule;
        
        if (isClosedRestaurant && !allowOrderForCustomSchedule) {
            setModalTitle('Alert');
            setModalMessage('Online ordering currently not available. You can try calling in your order.');
            setIsShowModal(true);
            return false;
        }

        if (item.is_sold_out || item.is_market_price) {
            return false;
        }

        if ('show_popup' === category.display_category_schedule && category.is_special_category) {
            const currentWorkHours = getWorkHours({...restaurant, business_hours: category.business_hours}, true);
            if (!!!currentWorkHours) {
                dispatch(showCategoryDisabledAlert(category));
                return false;
            }
        }

        if (cart.length === 0) {
            if (category.is_forced_schedule) {
                dispatch(cartSetSpecialCategory(category));
            }
            else if (!category.is_forced_schedule) {
                dispatch(cartResetSpecialCategory());
            }
        }
        else if (
            (category.is_forced_schedule && !specialCategory)
            || (!category.is_forced_schedule && specialCategory)
            || (
                (category.is_forced_schedule && specialCategory)
                && category.id !== specialCategory.id
            )
        ) {
            dispatch(showCartCategoryMixAlert(specialCategory ? specialCategory : category));
            return false;
        }
        // else if (category.id !== specialCategory.id) {
        //     return false;
        // }
        
        if (!!categoryGroup) {
            const isHasAnotherForcedSchedule =
                categoryGroup.is_use_custom_schedule
                && cartCategories.length !== 0
                && !cartCategoriesWithForcedScheduleIds.includes(category.id);

            const isHasForcedSchedule =
                !categoryGroup.is_use_custom_schedule
                && cartCategories.length !== 0
                && cartCategoriesWithForcedScheduleIds.length !== 0;
            
            const hasDifferentCategoryGroup = cartCategoryIds.some((categoryId) => !categoryGroup.categories.includes(categoryId));
            
            if (
                hasDifferentCategoryGroup
                && (
                    isHasForcedSchedule
                    || isHasAnotherForcedSchedule
                )
            ) {
                setModalTitle('Alert');
                setModalMessage(`Items from this Menu Group "${categoryGroup?.name || 'Unknown'}" cannot be mixed with items from other Menu Groups. Please update your cart and remove items if needed. You may want to make separate orders for each Menu Group.`);
                setIsShowModal(true);
                return false;
            }
        }
        
        dispatch(showMenuItem(item));
    };

    const handlerSearchItems = (e) => {
        e.preventDefault();
        setSearch(e.target.value);
    };

    const handlerClearSearchItems = (e) => {
        e.preventDefault();
        setSearch('');
    };

    const handleScrollTo = (e) => {
        e.preventDefault();

        const {
            target
        } = e;

        const parent = target.closest('.nav-category-item');

        let element = null;

        if (target.dataset.categoryId) {
            element = document.querySelector(target.dataset.categoryId);
        }
        else if (parent && parent.dataset.categoryId) {
            element = document.querySelector(parent.dataset.categoryId);
        }
        else {
            element = document.querySelector(target.getAttribute('href'));
        }
        
        if (!element) {
            return;
        }

        setScrollToElement(element);
    };

    const handleCategoryGroupChange = (e) => {
        const {value} = e.target;

        setCategoryGroup(+value);
    };

    const handleCloseModal = (e) => {
        setModalTitle('');
        setIsShowModal(false);
    };

    const handlerOrderMethod = (e) => {
        dispatch(setOrderMethod(e.target.value));
    };

    const handlerPaymentMethod = (e) => {
        dispatch(setPaymentMethod(e.target.value));
    };
    
    const handleCloseItemDialog = useCallback(() => dispatch(hideMenuItem()), [dispatch]);
    const handleConfirmItemDialog = useCallback((item) => dispatch(addItemToCart({ ...item, categoryGroupId: categoryGroup }, restaurant)), [dispatch, restaurant, categoryGroup]);
    
    const handleOpenCategoriesPopup = useCallback(() => setOpenCategoriesPopup(true), []);
    const handleCloseCategoriesPopup = useCallback(() => setOpenCategoriesPopup(false), []);
    
    const handleGoToCategoryPopup = useCallback((categorySelector) => () => {
        handleCloseCategoriesPopup();
        
        const element = document.querySelector(categorySelector);
        
        if (!element) {
            return;
        }

        setScrollToElement(element);
    }, [handleCloseCategoriesPopup]);

    useEffect(() => {
        if (isGroup !== !!group_id) {
            setIsGroup(!!group_id);
        }
    });
    
    useEffect(() => {
        const el = document.querySelector('#restaurantInfo > .restaurant-body');
        
        if (el && window.location.pathname.includes('/pos/')) {
            if (!el.classList.contains('pos')) {
                el.classList.add('pos');
            }
        }
        
        dispatch(showCartButton());
    }, []);

    useEffect(() => {
        if (!restaurant) {
            return;
        }

        setIsHideEstimateReadyMessage(restaurant.is_hide_est_ready_time);
        
        setIsOpen24Hours(!!(restaurant.open_24hrs && restaurant.open_24hrs.length));
        
        if (restaurant.open_24hrs && restaurant.open_24hrs.length) {
            setIsClosedRestaurant(false);
            setCurrentHours(null);
        }
        else {
            const currentWorkHours = getWorkHours({...restaurant}, true);
            const currentDeliveryWorkHours = getDeliveryWorkHours({...restaurant}, true);

            setIsClosedRestaurant(!currentWorkHours && !currentDeliveryWorkHours);
            // if (!currentWorkHours) {
            //     setIsClosedRestaurant(!currentWorkHours);
            //     setCurrentHours(restaurant.business_hours.find(h => h.dayNumber === restaurant.todayNumber));
            // }
            // else {
            //     setIsClosedRestaurant(!currentDeliveryWorkHours);
            //     setCurrentHours(restaurant.delivery_hours.find(h => h.dayNumber === restaurant.todayNumber));
            // }
            let hours = restaurant.business_hours.find(h => h.dayNumber === restaurant.todayNumber);
            if (!hours) {
                hours = restaurant.delivery_hours.find(h => h.dayNumber === restaurant.todayNumber);
            }
            setCurrentHours(hours);
        }
    }, [restaurant]);
    
    useEffect(() => {
        if (!stickyCategoriesRef.current) {
            return;
        }
        
        const { parentElement } = stickyCategoriesRef.current;
       parentElement.style.minHeight = `${parentElement.getBoundingClientRect().height}px`;

        setStickyCategoriesElOffset(cumulativeOffset(stickyCategoriesRef.current).top);
        
        document.querySelectorAll('img').forEach(img => {
            img.addEventListener('load', () => {
                setStickyCategoriesElOffset(cumulativeOffset(stickyCategoriesRef.current).top);
            }, false);
        });
    }, [stickyCategoriesRef.current]);
    
    useEffect(() => {
        if (!scrollCategoriesLeft.current) {
            return;
        }

        const handleScrollLeft = () => {
            if (!categoriesRef.current) {
                return;
            }
            
            categoriesRef.current.scrollLeft -= 100;
        };

        scrollCategoriesLeft.current.addEventListener('click', handleScrollLeft);
    }, [scrollCategoriesLeft.current]);
    
    useEffect(() => {
        if (!scrollCategoriesRight.current) {
            return;
        }

        const handleScrollRight = () => {
            if (!categoriesRef.current) {
                return;
            }
            
            categoriesRef.current.scrollLeft += 100;
        };

        scrollCategoriesRight.current.addEventListener('click', handleScrollRight);
    }, [scrollCategoriesRight.current]);
    
    useEffect(() => {
        // if (stickyCategoriesElOffset <= 0) {
        //     return;
        // }

        const list = {};

        const handleScroll = () => {
            if (!stickyCategoriesRef.current) { return; }
            
            if (window.pageYOffset >= stickyCategoriesElOffset) {
                if (stickyCategoriesRef.current.classList.contains('sticky')) {
                    let lastKey = null;

                    categorySlider.forEach(category => {
                        const key = `#category-${category.id}`;
                        const element = document.querySelector(key);
                        if (element) {
                            list[key] = cumulativeOffset(element).top - stickyCategoriesRef.current.getBoundingClientRect().height;
                        }
                    });
                    
                    Object.entries(list).forEach(([key, value]) => {
                        if (window.pageYOffset >= value) {
                            lastKey = key;
                        }
                    });
                    
                    if (null !== lastKey) {
                        document.querySelectorAll(`.sticky-categories .category-item.active`).forEach(el => {
                            el.classList.remove('active');
                        });
                        
                        const element = document.querySelector(`.sticky-categories .category-item[data-category-id="${lastKey}"]`);
                        if (element) {
                            element.classList.add('active');
                            
                                                if (
                                element.getBoundingClientRect().left < 0
                                || element.getBoundingClientRect().left + element.getBoundingClientRect().width > categoriesRef.current.getBoundingClientRect().width
                            ) {
                                categoriesRef.current.scrollLeft = element.offsetLeft - categoriesRef.current.getBoundingClientRect().left;
                            }
                        }
                    }
                    
                    return;
                }
                
                stickyCategoriesRef.current.classList.add('sticky');
            }
            else {
                stickyCategoriesRef.current.classList.remove('sticky');
            }
        };

        window.addEventListener('scroll', handleScroll);
        
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [stickyCategoriesElOffset]);

    useEffect(() => {
        setOfferItems(
            categorySlider.map((category, index) =>
                category.items.filter((item) =>
                    (item.special_offer.discount_rate && item.special_offer.discount_rate > 0)
                    || (item.special_offer.discount_value && item.special_offer.discount_value > 0)
                )
            ).reduce((acc, cur) => [...acc, ...cur], [])
        );

        setPopularItems(
            categorySlider.map((category, index) => {
                const items = category.items.filter(item => item.is_popular);
                if (items.length === 0) { return []; }
                if ('hide' === category.display_category_schedule && (category.is_special_category || category.is_forced_schedule)) {
                    const currentWorkHours = getWorkHours({...restaurant, business_hours: category.business_hours});
                    if (!!!currentWorkHours) { return []; }
                }
                return items;
            }).reduce((acc, cur) => [...acc, ...cur], [])
        );

        setData(categorySlider.filter((category) => !category.is_forced_schedule));
        setDataSpecial(categorySlider.filter((category) => category.is_forced_schedule));
    }, [categories, categorySlider]);

    useEffect(() => {
        setData(categorySlider
            .filter((category) => !category.is_forced_schedule)
            .map((category, index) => { return {...category, items: filterItems(category.items, search)}})
        );
        setDataSpecial(categorySlider
            .filter((category) => category.is_forced_schedule)
            .map((category, index) => { return {...category, items: filterItems(category.items, search)}})
        );
    }, [search]);

    useEffect(() => {
        if (!scrollToElement) { return; }

        setIsShowCategoriesMenu(false);

        setTimeout(() => {
            // scrollToElement.scrollIntoView({
            //     behavior: 'smooth'
            // });
            // const offsetPosition = scrollToElement.offsetTop - stickyCategoriesRef.current.offsetHeight;
            const offsetPosition = cumulativeOffset(scrollToElement).top - stickyCategoriesRef.current.offsetHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });

            setScrollToElement(null);
        }, 150);

    }, [scrollToElement]);

    useEffect(() => {
        if (!categoryGroup) {
            setCategorySlider(categories.filter(category => {
                if (category.items.length === 0) { return false; }
                if ('hide' === category.display_category_schedule && (category.is_special_category || category.is_forced_schedule)) {
                    const currentWorkHours = getWorkHours({...restaurant, business_hours: category.business_hours});
                    if (!!!currentWorkHours) { return false; }
                }

                return true;
            }));

            return;
        }

        const group = restaurant.menu_category_groups.find(g => g.id === categoryGroup);
        if (!group) {
            return;
        }

        setCategorySlider(categories.filter(category => {
            if (category.items.length === 0) { return false; }
            if ('hide' === category.display_category_schedule && (category.is_special_category || category.is_forced_schedule)) {
                const currentWorkHours = getWorkHours({...restaurant, business_hours: category.business_hours});
                if (!!!currentWorkHours) { return false; }
            }
            if (!group.categories.includes(category.id)) { return false; }

            return true;
        }));
    }, [categoryGroup]);

    useEffect(() => {
        if (restaurant && restaurant.menu_category_groups.some(group => group.id === restaurant.default_category_group_id)) {
            setCategoryGroup(restaurant.default_category_group_id);
        }
        else if (restaurant && restaurant.menu_category_groups &&restaurant.menu_category_groups.length > 0) {
            setCategoryGroup(restaurant.menu_category_groups[0].id);
        }
        else if (categories) {
            setCategorySlider(categories.filter(category => {
                if (category.items.length === 0) { return false; }
                if ('hide' === category.display_category_schedule && (category.is_special_category || category.is_forced_schedule)) {
                    const currentWorkHours = getWorkHours({...restaurant, business_hours: category.business_hours});
                    if (!!!currentWorkHours) { return false; }
                }

                return true;
            }));
        }
    }, [restaurant, categories]);

    useEffect(() => {
        if (!restaurant) return;
        
        if (!specialCategory && restaurant.delivery_method.length !== 0 && !restaurant.delivery_method.includes(orderMethod)) {
            dispatch(setOrderMethod(restaurant.delivery_method[0]));
        }
        else if (specialCategory && specialCategory.available_methods.length > 0 && specialCategory.delivery_method && !specialCategory.delivery_method.includes(orderMethod)) {
            dispatch(setOrderMethod(specialCategory.available_methods[0]));
        }
        
        if (!restaurant.payment_method.includes(paymentMethod)) {
            dispatch(setPaymentMethod(restaurant.payment_method[0]));
        }
        
        setIsHaveOrderPaymentMethods(restaurant.payment_method.length > 1);
    }, [restaurant]);

    useEffect(() => {
        if (!restaurant) return;
        
        let is_pickup = restaurant.delivery_method.includes(orderMethods.pickup);
        let is_delivery = restaurant.delivery_method.includes(orderMethods.delivery);
        let is_doordash_delivery = restaurant.delivery_method.includes(orderMethods.doordash_delivery);
        let is_uber_delivery = restaurant.delivery_method.includes(orderMethods.uber_delivery);

        if (specialCategory && !specialCategory.available_methods.includes(orderMethods.pickup)) {
            is_pickup = false;
        }
        if (specialCategory && !specialCategory.available_methods.includes(orderMethods.delivery)) {
            is_delivery = false;
        }
        if (specialCategory && !specialCategory.available_methods.includes(orderMethods.doordash_delivery)) {
            is_doordash_delivery = false;
        }
        if (specialCategory && !specialCategory.available_methods.includes(orderMethods.uber_delivery)) {
            is_uber_delivery = false;
        }

        if (!specialCategory && restaurant.delivery_method.length !== 0 && !restaurant.delivery_method.includes(orderMethod)) {
            dispatch(setOrderMethod(restaurant.delivery_method[0]));
        }
        else if (specialCategory && specialCategory.available_methods.length > 0 && specialCategory.delivery_method && !specialCategory.delivery_method.includes(orderMethod)) {
            dispatch(setOrderMethod(specialCategory.available_methods[0]));
        }
        
        // setIsHaveOrderMethods(is_pickup && is_delivery);
        
        const activeDeliveries = [is_pickup, is_delivery, is_doordash_delivery, is_uber_delivery]
            .filter((v) => v)
            .length > 1;
        setIsHaveOrderMethods(activeDeliveries);
    }, [restaurant, orderMethod, specialCategory]);
    
    useEffect(() => {
        if (!deepEqual(restaurant, window.vendorData)) {
            dispatch(getRestaurantData());
        }
    }, [cart]);

    if (!restaurant) {
        return (
            <Loader/>
        );
    }

    if (restaurant && restaurant.is_pause_website) {
        return (
            <MenuPaused/>
        );
    }

    if (restaurant && restaurant.is_closed) {
        return (
            <MenuClosed/>
        );
    }
    
    return (
        <>
            <SelectMenuItemDialog
                confirmLabel="Add to Cart"
                item={selectedItem}
                onClose={handleCloseItemDialog}
                onConfirm={handleConfirmItemDialog}
            />

            <MenuCategoryAlert />
            <CartCategoryMixAlert />

            <div className="left-categories">
                <h3 className="font-weight-bold text-center" style={{color: theme.category_label_color}}>Categories</h3>
                <ul>
                    {data.map((category, index) => (
                        <li className="nav-category-item" key={index} data-category-id={`#category-${category.id}`} onClick={handleScrollTo}>
                            <div className="card w-100">
                                <div className="card-horizontal">
                                    <div className="card-body">
                                        <h6 className="font-weight-bold" style={{color: theme.category_label_color}}>
                                            {category.name}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="menu-content">
                {(isHaveOrderMethods || isHaveOrderPaymentMethods) && (
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex my-3" style={{ gap: '1rem', }}>
                                {!isHaveOrderPaymentMethods && (<div />)}
                                {isHaveOrderPaymentMethods && (
                                    <div className="switch-group order-type-switch" style={{ width: '250px', '--height': '35px', }}>
                                        <div className="switch-button">
                                            <input type="radio" name="order_payment_method" id="switch_cash" value="cash"
                                                   checked={paymentMethod === paymentMethods.cash}
                                                   onChange={handlerPaymentMethod} />
                                            <label htmlFor="switch_cash">
                                                Cash
                                            </label>
                                        </div>
                                        <div className="switch-button">
                                            <input type="radio" name="order_payment_method" id="switch_card" value="card"
                                                   checked={paymentMethod === paymentMethods.card}
                                                   onChange={handlerPaymentMethod} />
                                            <label htmlFor="switch_card">
                                                Credit Card
                                            </label>
                                        </div>
                                    </div>
                                )}

                                {restaurant.is_enabled_group_order && !isGroup && (
                                    <div className="text-center" style={{ height: '35px', }}>
                                        <a
                                            className="btn btn-outline-danger"
                                            href={`https://www.fastordernow.com/restaurant/${window.vendor}/group/type`}
                                            target="_self"
                                        >
                                            {/*Start Group Order*/}
                                            Group
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/*<div className="col-md-6">*/}
                        {/*    */}
                        {/*    /!*{isHaveOrderMethods && (*!/*/}
                        {/*    /!*    <div className="switch-group order-type-switch my-3">*!/*/}
                        {/*    /!*        <div className="switch-button">*!/*/}
                        {/*    /!*            <input type="radio" name="order_method" id="switch_delivery" value="delivery" checked={orderMethod === orderMethods.delivery} onChange={handlerOrderMethod} />*!/*/}
                        {/*    /!*            <label htmlFor="switch_delivery">*!/*/}
                        {/*    /!*                Delivery*!/*/}
                        {/*    /!*            </label>*!/*/}
                        {/*    /!*        </div>*!/*/}
                        {/*    /!*        <div className="switch-button">*!/*/}
                        {/*    /!*            <input type="radio" name="order_method" id="switch_delivery" value="doordash_delivery" checked={orderMethod === orderMethods.doordash_delivery} onChange={handlerOrderMethod} />*!/*/}
                        {/*    /!*            <label htmlFor="switch_delivery">*!/*/}
                        {/*    /!*                DoorDash*!/*/}
                        {/*    /!*            </label>*!/*/}
                        {/*    /!*        </div>*!/*/}
                        {/*    /!*        <div className="switch-button">*!/*/}
                        {/*    /!*            <input type="radio" name="order_method" id="switch_delivery" value="uber_delivery" checked={orderMethod === orderMethods.uber_delivery} onChange={handlerOrderMethod} />*!/*/}
                        {/*    /!*            <label htmlFor="switch_delivery">*!/*/}
                        {/*    /!*                Uber*!/*/}
                        {/*    /!*            </label>*!/*/}
                        {/*    /!*        </div>*!/*/}
                        {/*    /!*        <div className="switch-button">*!/*/}
                        {/*    /!*            <input type="radio" name="order_method" id="switch_pickup" value="pickup" checked={orderMethod === orderMethods.pickup} onChange={handlerOrderMethod} />*!/*/}
                        {/*    /!*            <label htmlFor="switch_pickup">*!/*/}
                        {/*    /!*                Pickup*!/*/}
                        {/*    /!*            </label>*!/*/}
                        {/*    /!*        </div>*!/*/}
                        {/*    /!*    </div>*!/*/}
                        {/*    /!*)}*!/*/}
                        {/*</div>*/}
                    </div>
                )}
                <div className="row">
                    <div className="col-md-12">

                        <div className="alert alert-default" role="alert">
                            <p className="mb-3">
                                <i className="fas fa-directions"></i>&nbsp;{restaurantAddress}
                            </p>
                            
                            {!isHideEstimateReadyMessage && (!isClosedRestaurant || restaurant.default_estimate_ready_time <= 0) && (
                                <p>
                                    <i className="far fa-comment-dots"></i>&nbsp;Current prep time
                                    is {restaurant.default_estimate_ready_time} minutes.
                                </p>
                            )}
                            {isClosedRestaurant && (
                                <p>
                                    <i className="fas fa-comment-dots"></i>&nbsp;Online ordering currently not
                                    available. You can try calling in your order.
                                </p>
                            )}
                            {currentHours && (
                                <p>
                                    <i className="far fa-clock"></i>&nbsp;{currentHours.dayFull}: {currentHours.begin} to {currentHours.end}&nbsp;
                                    <a href="#more_info" className="alert-link" onClick={handleToggleShowMoreInfo}>More
                                        info</a>
                                </p>
                            )}
                            {isOpen24Hours && (
                                <p>
                                    <i className="far fa-clock"></i>&nbsp;Open 24 hours&nbsp;<a href="#more_info" className="alert-link" onClick={handleToggleShowMoreInfo}>More info</a>
                                </p>
                            )}
                            {restaurant.phone && (
                                <p>
                                    <i className="fas fa-phone-alt"></i>&nbsp;Phone: <a href={`tel:${restaurant.phone}`} className="alert-link">{restaurant.phone}</a>
                                </p>
                            )}
                            {restaurant.is_show_vendor_email && restaurant.email && (
                                <p>
                                    <i className="fas fa-envelope"></i>&nbsp;Email: <a href={`mailto:${restaurant.email}`} className="alert-link">{restaurant.email}</a>
                                </p>
                            )}
                        </div>
                        
                        <Modal isOpen={isShowMoreInfo} onClose={handleToggleShowMoreInfo} title={restaurant.name}>
                            <MoreInfo />
                        </Modal>
                        
                        {/*<div className={classNames('alert alert-warning', {'d-none': !isClosedRestaurant})} role="alert">*/}
                        {/*    <i className="far fa-clock"></i>&nbsp;Online ordering is currently closed because it is near closing time. Please tap on the upper right clock icon for regular business hours.*/}
                        {/*</div>*/}

                        {/*
                        // FIXME: search
                        <div className="input-group my-3">
                            <input type="text"
                                   className="form-control"
                                   placeholder="Search Item"
                                   aria-label="Search Item"
                                   aria-describedby="Item search"
                                   style={{order: 'unset'}}
                                   onChange={handlerSearchItems}
                                   value={search}
                            />
                            <div className={classNames('input-group-append', {'d-none': search.length === 0})} style={{marginRight: '-1px', marginBottom: '-1px', marginTop: '-1px'}}>
                                <button className="btn btn-danger"
                                        type="button"
                                        onClick={handlerClearSearchItems}
                                        style={{
                                            color: theme.floating_order_button_font_color,
                                            backgroundColor: theme.floating_order_button_background_color,
                                            borderColor: theme.floating_order_button_background_color,
                                        }}
                                >Clear Search</button>
                            </div>
                        </div>
                        */}

                        {/*<div className="dropdown d-inline-block mt-3">*/}
                        {/*    <button */}
                        {/*        className="btn btn-secondary dropdown-toggle"*/}
                        {/*        type="button"*/}
                        {/*        id="dropdownSelectCategory"*/}
                        {/*        data-toggle="dropdown" */}
                        {/*        aria-haspopup="true"*/}
                        {/*        aria-expanded="false"*/}
                        {/*        onClick={() => setIsShowCategoriesMenu(prevState => !prevState)}*/}
                        {/*    >*/}
                        {/*        Select Category*/}
                        {/*    </button>*/}
                        {/*    <div className={classNames('dropdown-menu', {'d-block': isShowCategoriesMenu})} aria-labelledby="dropdownSelectCategory">*/}
                        {/*        {data.map((category, index) => (*/}
                        {/*            <a className="dropdown-item" href={`#category-${category.id}`} key={index} onClick={handleScrollTo}>{category.name}</a>*/}
                        {/*        ))}*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {/*<div className="row mt-3 d-none d-md-block">*/}
                        {/*    {data.map((category, index) => (*/}
                        {/*        <div className="col-md-3 mb-2 d-inline-flex nav-category-item" key={index} data-category-id={`#category-${category.id}`} onClick={handleScrollTo}>*/}
                        {/*            <div className="card w-100">*/}
                        {/*                <div className="card-horizontal">*/}
                        {/*                    <div className="card-body">*/}
                        {/*                        <h6 className="font-weight-bold text-danger">*/}
                        {/*                            {category.name}*/}
                        {/*                        </h6>*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    ))}*/}
                        {/*</div>*/}

                        {restaurant && restaurant.menu_category_groups.length !== 0 && (
                        <div className="alert alert-default">
                            <div
                                className="sticky-categories-navbar pt-3"
                                style={{ borderTop: 'unset', borderBottom: 'unset', }}
                            >
                                {restaurant && restaurant.menu_category_groups.length !== 0 && (
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="select m-3"
                                                 style={{ '--select-color': theme.category_label_color }}>
                                                <select className="select-text text-primary"
                                                        style={{ lineHeight: '1.2rem' }} value={categoryGroup}
                                                        onChange={handleCategoryGroupChange}>
                                                    {/*
                                                <option value="" disabled selected></option>
                                                */}
                                                    {restaurant.menu_category_groups.map(group => (
                                                        <option value={group.id}>{group.name}</option>
                                                    ))}
                                                </select>
                                                <span className="select-highlight"></span>
                                                <span className="select-bar"></span>
                                                <label className="select-label">Select Menu</label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/*
                            // FIXME: list of categories
                            <div className="categories-wrapper">
                                <div
                                    className="categories-popup-button"
                                    role="button"
                                    tabIndex={0}
                                    onClick={handleOpenCategoriesPopup}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                        <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/>
                                    </svg>
                                </div>

                                <FullScreenPopup isOpen={openCategoriesPopup} onClose={handleCloseCategoriesPopup}>
                                    <div className="list-group">
                                        {categorySlider.map(category => (
                                            <button
                                                type="button"
                                                className="list-group-nav-item list-group-item-action"
                                                key={category.id}
                                                onClick={handleGoToCategoryPopup(`#category-${category.id}`)}
                                            >
                                                <span className="font-weight-bold">{category.name}</span>
                                            </button>
                                        ))}
                                    </div>
                                </FullScreenPopup>
                                
                                <div className="sticky-categories no-scroll" style={{'--font-color': theme.scrolling_category_font_color}} ref={categoriesRef}>
                                    {categorySlider.map(category => (
                                        <div className="category-item nav-category-item" key={category.id} data-category-id={`#category-${category.id}`} onClick={handleScrollTo}>
                                            <h6 className="font-weight-bold category-item-label">{category.name}</h6>
                                        </div>
                                    ))}
                                </div>
                                <div className="left-nav" ref={scrollCategoriesLeft}>
                                    <i className="fas fa-chevron-left"></i>
                                </div>
                                <div className="right-nav" ref={scrollCategoriesRight}>
                                    <i className="fas fa-chevron-right"></i>
                                </div>
                            </div>
                            */}

                            </div>
                        </div>
                        )}
                        
                    </div>
                </div>

                <div>
                    <button type="button" className="btn btn-link text-dark" onClick={handleToggleExpandedAllCategories}>
                        {!expandedAllCategories && (
                            <span><i className="fas fa-circle-plus"></i> Expand Menu</span>
                        )}
                        {expandedAllCategories && (
                            <span><i className="fas fa-circle-minus"></i> Collapse Menu</span>
                        )}
                    </button>
                </div>

                <ul className="fon-accordion">
                    {popularItems.length > 0 && (
                        <li className={classNames({ 'fon-open': true })} key={-1}>
                            <div className="fon-accordion-header restaurant-menu__header__height no-compact"
                                 // onClick={handlerCategoryToggle}
                            >
                                <div>
                                    <h3 style={{
                                        color: theme.category_label_color,
                                        borderBottomColor: theme.category_underline_color
                                    }}>Popular Items</h3>
                                </div>
                            </div>
                            <div className="fon-accordion-body">
                                <div className="row">
                                    {filterItems(popularItems, search).map((item) => (
                                        <CategoryItem item={item} theme={theme} onClick={handlerShowMenuItem} />))}
                                </div>
                            </div>
                        </li>
                    )}
                    {dataSpecial.map((category, index) => (
                        <Category
                            index={index}
                            category={category}
                            restaurant={restaurant}
                            theme={theme}
                            onClickItem={handlerShowMenuItem}
                            defaultExpanded={expandedAllCategories}
                        />
                    ))}
                    {offerItems.length > 0 && (
                        <li className={classNames({ 'fon-open': expandedAllCategories })} key={-1}>
                            <div className="fon-accordion-header restaurant-menu__header__height no-compact"
                                 onClick={handlerCategoryToggle}>
                                <div>
                                    <h3 style={{
                                        color: theme.category_label_color,
                                        borderBottomColor: theme.category_underline_color
                                    }}>Special Offer</h3>
                                </div>
                            </div>
                            <div className="fon-accordion-body">
                                <div className="row">
                                    {filterItems(offerItems, search).map((item) => (
                                        <CategoryItem item={item} theme={theme} onClick={handlerShowMenuItem} />))}
                                </div>
                            </div>
                        </li>
                    )}
                    {data.map((category, index) => (
                        <Category
                            index={index}
                            category={category}
                            restaurant={restaurant}
                            theme={theme}
                            onClickItem={handlerShowMenuItem}
                            defaultExpanded={expandedAllCategories}
                        />
                    ))}
                </ul>
            </div>

            <div id="dlgNextWarning" className={classNames('modal fade', { show: isShowModal })} tabIndex="-1"
                 role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            {modalTitle.length === 0 && (
                                <h5 className="modal-title">Missing Information</h5>
                            )}
                            {modalTitle.length > 0 && (
                                <h5 className="modal-title">{modalTitle}</h5>
                            )}
                        </div>
                        <div className="modal-body">
                            <p dangerouslySetInnerHTML={{ __html: modalMessage }}></p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dlg-primary pl-4 pr-4"
                                    onClick={handleCloseModal}>OK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

function Category({ index, category, restaurant, theme, onClickItem, defaultExpanded = true }) {
    const [isOpen, setIsOpen] = useState(defaultExpanded);

    useEffect(() => {
        setIsOpen(defaultExpanded);
    }, [defaultExpanded]);
    
    if (category.items.length === 0) {
        return null;
    }
    
    if ('hide' === category.display_category_schedule && (category.is_special_category || category.is_forced_schedule)) {
        const currentWorkHours = getWorkHours({ ...restaurant, business_hours: category.business_hours });
        if (!!!currentWorkHours) {
            return null;
        }
    }
    
    return (
        <li className={classNames({ 'fon-open': isOpen })} key={index} id={`category-${category.id}`}>
            <div className="fon-accordion-header restaurant-menu__header__height no-compact"
                 onClick={() => setIsOpen(prevState => !prevState)}>
                <div>
                <h3 className="d-flex justify-content-between" style={{cursor: 'pointer', color: theme.category_label_color, borderBottomColor: theme.category_underline_color}}>
                        <span>
                            {category.is_special_category && (<i className="fas fa-certificate mr-1"></i>)}{category.name}{false && (<span className="text-danger">&nbsp;[CLOSE]</span>)}
                        </span>
                        {isOpen ?
                            (
                                <i className="fas fa-angle-up"></i>
                            )
                            : (
                                <i className="fas fa-angle-down"></i>
                            )
                        }
                    </h3>
                        
                    {category.description && (<p className="text-left" style={{color: '#000'}}>{category.description}</p>)}
                </div>
            </div>
            <div className="fon-accordion-body">
                <div className="row">
                    {category.items.map((item) => (<CategoryItem item={item} theme={theme} onClick={onClickItem} />))}
                </div>
            </div>
        </li>
    )}

function CategoryItem({item, theme, onClick}) {
    const handlerShowMenuItem = onClick;
    return (
        <div className="col-md-6 mb-2">
            <div className="menu-item menu-item-bordered" onClick={(e) => { handlerShowMenuItem(e, item) }}>

                {item.image_url.length > 0 && (
                    <img
                        src={item.image_url}
                        className="icon shadow"
                    />
                )}

                <div className="menu-info-left">
                    <h3 className="menu-name">
                        {item.name}{item.is_sold_out && (<span className="sold-out pl-1">(Sold Out)</span>)}{((item.special_offer.discount_rate && item.special_offer.discount_rate > 0) || (item.special_offer.discount_value && item.special_offer.discount_value > 0)) && (<span className="sold-out pl-1">(Special Offer)</span>)}
                        {item.spicy_level > 0 && (
                            <span className="pl-2 text-danger">
                                {[...Array(item.spicy_level)].map((i) => (<i className="fas fa-pepper-hot"></i>))}
                            </span>
                        )}
                    </h3>
                    <p className="menu-description">{item.description}</p>
                </div>
                <div className="menu-info-right">
                    <div className="menu-price" style={{color: theme.prices_color}}>
                        {item.is_market_price && ('MARKET')}
                        {!item.is_market_price && item.price > 0 && `$${(item.price).toFixed(2)} `}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Menu);